import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthProvider';
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Provider } from 'react-redux';
import { store } from './redux';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import ScrollToTop from './context/ScrollToTop';
import { GoogleOAuthProvider } from '@react-oauth/google';

import './i18n'
import { Toaster } from 'react-hot-toast';

const queryclient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      staleTime: Infinity
    }
  }
})

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);



root.render(
    <QueryClientProvider client={queryclient}>
      <BrowserRouter basename=''>
        <Toaster />
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENTID}>
          <Provider store={store}>
              <AuthProvider>
                  <ScrollToTop />
                  <Routes>
                    <Route path="/*" element={<App />}></Route>
                  </Routes> 
              </AuthProvider>
          </Provider>
        </GoogleOAuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
);
